export default __webpack_public_path__ + "static/media/grid.1ca3ef07.svg";